/* eslint-disable no-empty-pattern */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Login } from "./Login/Login";
import { NavBar, MobileHeader } from "../components";

import { LogOut } from "./Login/Logout";
import { Profile } from "./Dashboard/Profile/Profile";
import React, { useEffect, useState } from "react";
import { NotFoundPage } from "./NotFoundPage";
import { ResetPassword } from "./Login/ResetPassword";
import { MyProfile } from "./Dashboard/StafProfile/MyProfile";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { userLogin } from "../redux/reducers";
import { Leads } from "./Dashboard/Leads";
import { Projects } from "./Dashboard/projects";
import { InsuranceCompanies } from "./Dashboard/InsuranceCompany";
import { ProjectDescription } from "./Dashboard/ProjectDetails";
import { Materials } from "./Dashboard/Materials";
import { Users } from "./Dashboard/Users/Users";
import { Waitlist } from "./Dashboard/Waitlist";

import MaterialCreation from "./Dashboard/ItemCreation";
import { Box } from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";

import { MapPage } from "./MapPage";
import { AllowRoutesProps, PageType } from "../types/interface";
import ForgotPassword from "./Login/ForgotPassword";
import CreateProject from "./Dashboard/projects/CreateProject";
import { ProjectWorkflow } from "./Dashboard/ProjectWorkflow";
import { AnalyticsDashboard } from "./Dashboard/AnalyticsDashboard";
import { Notifications } from "./Dashboard/Notifications";
import { SalesEstimateCalculator } from "./Dashboard/SalesEstimateCalculator";
import { Customers } from "./Dashboard/Customers";
import { CustomerDetail } from "./Dashboard/Customers/CustomerDetail";
import { CustomerProjectCreate } from "./Dashboard/Customers/CustomerProjectCreate";
import { FileManager } from "./Dashboard/FileManager";
import { useAmplitudePageTracking } from "../hooks/useAmplitudePageTracking";
import { setUserProperties } from "../utils/amplitude";

// Sidebar width constant
const SIDEBAR_WIDTH = 75;

const availablePages: PageType[] = [
  {
    pageName: "leads",
    component: <Leads />,
  },
  {
    pageName: "profile",
    component: <Profile />,
  },
  {
    pageName: "my-profile",
    component: <MyProfile />,
  },

  {
    pageName: "logout",
    component: <LogOut />,
  },
];

const AllowedRoutes: React.FC<AllowRoutesProps> = () => {
  const dispatch = useAppDispatch();
  const profile = useAppSelector((state) => state.userReducer).userProfile;
  const permissions = useAppSelector((state) => state.userReducer.permissions);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      dispatch(userLogin({ token, _id: "" }));
    }
  }, []);

  // Identify user when profile and permissions are loaded
  useEffect(() => {
    if (profile.token && profile.userDetails?.email) {
      setUserProperties(profile.userDetails.email, {
        email: profile.userDetails.email,
        user_id: profile._id || profile.userDetails.email,
        first_name: profile.userDetails.firstName,
        last_name: profile.userDetails.lastName,
        phone: profile.userDetails.phone,
      });
    }
    
    // Update user properties when permissions change
    if (profile.token && profile.userDetails?.email && permissions.length > 0) {
      setUserProperties(profile.userDetails.email, {
        permissions: permissions.map(p => p.name),
      });
    }
  }, [profile.token, profile.userDetails, permissions]);

  if (profile.token) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: "#F3F3F3",
        }}>
        <Routes>
          <Route path="/dashboard" element={<Leads />} />
          <Route path="/analytics-dashboard" element={<AnalyticsDashboard />} />
          <Route path="/logout" element={<LogOut />} />
          <Route path="/material-create" element={<MaterialCreation />} />
          <Route path="/self-reset-password" element={<ResetPassword />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="/waitlist" element={<Waitlist />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/project-create" element={<CreateProject />} />
          <Route path="/insurance" element={<InsuranceCompanies />} />
          <Route path="/projects/:id" element={<ProjectDescription />} />
          <Route path="/manage-project/:id" element={<ProjectWorkflow />} />
          <Route path="/materials" element={<Materials />} />
          <Route path="/users" element={<Users />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/customers/:id" element={<CustomerDetail />} />
          <Route path="/customer-project-create/:customerId" element={<CustomerProjectCreate />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/file-manager" element={<FileManager />} />
          <Route path="/sales-estimate-calculator" element={<SalesEstimateCalculator />} />
          <Route path="/" element={<Leads />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    );
  } else {
    return (
      <Routes>
        <Route path="/self-reset-password" element={<ResetPassword />} />
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    );
  }
};

interface RouteManagerProps {}

const FullScreenLayout = () => {
  const location = useLocation();
  const profile = useAppSelector((state) => state.userReducer).userProfile;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  // Track page views automatically
  useAmplitudePageTracking();

  const isLoggedIn = profile.token;

  const theme = useTheme();
  // Mobile: < 768px (md breakpoint)
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <Box
      display="flex"
      width="100vw"
      minHeight="100vh"
      flexDirection="column"
      style={{ backgroundColor: "#F3F3F3" }}
    >
      {/* Mobile Header - only show on mobile when logged in */}
      {isLoggedIn && isMobile && (
        <MobileHeader 
          onMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)}
          isMenuOpen={mobileMenuOpen}
        />
      )}

      <Box display="flex" flex={1} flexDirection="row">
        {/* Desktop Sidebar - hidden on mobile */}
        {isLoggedIn && !isMobile && (
          <Box
            sx={{
              backgroundColor: "black",
              width: `${SIDEBAR_WIDTH}px`,
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                position: "fixed",
                top: 0,
                left: 0,
                bottom: 0,
                width: `${SIDEBAR_WIDTH}px`,
                height: "100%",
              }}
            >
              <NavBar />
            </Box>
          </Box>
        )}

        {/* Mobile Sidebar Drawer */}
        {isLoggedIn && isMobile && (
          <NavBar 
            isMobile={true} 
            mobileOpen={mobileMenuOpen} 
            onMobileClose={() => setMobileMenuOpen(false)} 
          />
        )}

        {/* Main Content */}
        <Box
          sx={{
            flex: 1,
            minHeight: isLoggedIn && isMobile ? "calc(100vh - 56px)" : "100vh",
            overflow: "auto",
            width: "100%",
          }}
        >
          <AllowedRoutes />
        </Box>
      </Box>
    </Box>
  );
};

export const RouteManager: React.FC<RouteManagerProps> = ({}) => {
  return (
    <BrowserRouter>
      <FullScreenLayout />
    </BrowserRouter>
  );
};
